module.exports = __webpack_public_path__ + "static/media/brand-refresh-Rewards.351e783a.svg";